var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('c-panel',[_c('form-categoria',{attrs:{"paramId":_vm.$route.params.id},on:{"onSubmitCategoria":_vm.onSubmitCategoria}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }